import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-um',
  templateUrl: './um.component.html',
  styleUrls: ['./um.component.css']
})
export class UmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
